<template>
  <div :style="css">
    <Loading v-if="loading" />

    <v-container v-else class="py-10 py-sm-12 py-md-14 py-lg-16">
      <PagesTitle :mod="mod">Calendário de Vacinas</PagesTitle>
      <div
        class="
          d-flex
          justify-center
          flex-wrap
          items-schedule
          pt-sm-11 pt-5
          pb-4
        "
      >
        <div
          v-for="({ title, file }, itemKey) in items"
          :key="itemKey"
          class="items-schedule-item"
        >
          <a
            @click="downloadWithAxios(files + file, title, file.split('.')[1])"
            :href="files + file"
            class="
              d-flex
              justify-center
              align-center
              text-center
              px-3
              text-caption text-sm-body-1
              font-weight-medium
            "
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>
              {{ title }}
            </span>
          </a>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-schedule",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    colors: {
      type: Array,
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.items = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    css() {
      return {
        "--page-color-primary": this.colors[0],
        "--page-color-secondary": this.colors[1],
      };
    },
  },
  methods: {
    forceFileDownload(response, title, type) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const scheduleNameBase = `Calendário de Vacinas -  ${title}`;
      switch (type) {
        case "pdf":
          link.setAttribute("download", scheduleNameBase + ".pdf");
          break;
        case "png":
          link.setAttribute("download", scheduleNameBase + ".png");
          break;
        case "jpg":
          link.setAttribute("download", scheduleNameBase + ".jpg");
          break;
        case "jpeg":
          link.setAttribute("download", scheduleNameBase + ".jpeg");
          break;
        case "svg":
          link.setAttribute("download", scheduleNameBase + ".svg");
          break;
        default:
          link.setAttribute("download", scheduleNameBase);
      }

      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios(url, title, type) {
      event.preventDefault();
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title, type);
        })
        .catch(() => console.log("error occured"));
    },
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.page-color-primary {
  background-color: var(--page-color-primary) !important;
}
.page-color-primary--text {
  color: var(--page-color-primary) !important;
}

.items-schedule {
  gap: 12px;
  @media (max-width: 960px) {
    gap: 20px;
  }

  &-item a {
    height: 76px;
    width: 153px;
    background-color: var(--page-color-secondary);
    border-radius: 8px;
    color: var(--page-color-primary);
    text-decoration: none;
    font-size: 16px;
    transition: all 0.15s ease-in-out;
    @media (max-width: 380px) {
      height: 64px;
      width: 130px;
    }

    &:hover {
      background-color: var(--page-color-primary);
      color: #fff;
    }
  }
}
</style>
